import { useEffect, useState } from 'react'
import { checkOffMorning } from 'utils/common'
import { convertTo24HourFormat } from '../../../utils/dateTime'

type RenderFirstInProps = {
  firstIn: string
  lastOut: string
  isHalfDay: boolean
  submitClick: () => void
}
export const LastOut = ({ firstIn, lastOut, isHalfDay, submitClick }: RenderFirstInProps) => {
  const [isWrongTime, setIsWrongTime] = useState(false)
  const [isWrongFistIn, setIsWrongFistIn] = useState(false)

  useEffect(() => {
    if (lastOut) {
      const date = new Date(`2024-06-11 ${lastOut}`)
      const hours = date.getHours()
      const minutes = date.getMinutes()
      if (isHalfDay) {
        //Kiểm tra xem nghỉ buổi sáng hay chiều. nếu thời gian làm buổi sáng nhiều hơn thì là nghỉ buổi chiều và ngược lại.
        //Dựa vào kết quả nghỉ sáng hay chiều sẽ điều chỉnh điều kiện cho phù hợp
        if (checkOffMorning(new Date(`2024-06-11 ${firstIn}`), new Date(`2024-06-11 ${lastOut}`))) {
          if (hours < 16 || (hours === 16 && minutes < 30)) {
            setIsWrongTime(true)
          }
        } else {
          if (hours < 12) {
            setIsWrongTime(true)
          }
        }
      } else {
        if (hours < 16 || (hours === 16 && minutes < 30)) {
          setIsWrongTime(true)
        }
      }
    }
  }, [])

  return lastOut ? (
    <div
      className={`${isWrongTime ? 'text-red-500  cursor-pointer bg-white px-2 rounded-md' : 'text-white'} font-bold`}
    >
      {convertTo24HourFormat(lastOut)}
    </div>
  ) : (
    <label
      className="text-red-500  cursor-pointer bg-white px-2 rounded-md"
      onClick={() => {
        submitClick()
      }}
    >
      -
    </label>
  )
}
